module.exports = __webpack_public_path__ + "img/card_nevi_ElecrtrifyAmerica_2.3fe6a308.png";